import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MultiSelect } from 'primeng/multiselect';
import { FloatLabel } from 'primeng/floatlabel';
import { HandlingUnit } from '@myarvato/modules/transport/models';

@Component({
  selector: 'transport-multi-unit-selection',
  imports: [TranslatePipe, FormsModule, MultiSelect, FloatLabel],
  templateUrl: './multi-unit-selection.component.html',
  styleUrl: './multi-unit-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiUnitSelectionComponent {
  public readonly handlingUnits = input.required<HandlingUnit[]>();

  public readonly selectedHandlingUnits = model<HandlingUnit[]>([]);
}
